import { useEffect, useState } from 'react'

const STORAGE_KEY = 'certi-theme'

export default function ThemeToggle() {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'dark' || saved === 'light') return saved
    const prefersDark = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    return prefersDark ? 'dark' : 'light'
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  const toggle = () => setTheme(prev => (prev === 'light' ? 'dark' : 'light'))

  return (
    <button
      aria-label="Toggle theme"
      onClick={toggle}
      className="nav-pill"
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {theme === 'light' ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zm10.48 0l1.79-1.8 1.41 1.41-1.8 1.79-1.4-1.4zM12 4V1h-1v3h1zm5 8a5 5 0 11-10.001.001A5 5 0 0117 12zM4 13H1v-1h3v1zm9 9h-1v-3h1v3zm7-9v-1h3v1h-3zM6.76 19.16l-1.42 1.42-1.79-1.8 1.41-1.41 1.8 1.79zm11.47-1.8l1.8 1.79-1.41 1.41-1.79-1.8 1.4-1.4z"/>
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21.64 13a9 9 0 11-10.63-10.64 1 1 0 00.88 1.5 7 7 0 109.77 9.77 1 1 0 001.5.88z"/>
        </svg>
      )}
    </button>
  )
}

